var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isPwaLayout || !_vm.isLayoutDefined)?_c('router-view'):_c(_vm.layout,{tag:"component"}),_c('PwaInstallPrompt')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }